import React from "react";
import cx from "classnames";
import { SelectChangeEvent } from "@mui/material";

import s from "./styles.module.css";
import Select from "../../../../components/ui/Select";
import {
  EProcessingStatuses,
  EDeprecatedInvoiceStatusesLiveFundedTrader,
} from "../../../../constants";

interface IProps {
  value: string | number;
  id: number;
  accounts_id: number;
  handleChange: (e: SelectChangeEvent<string>, id: number, accounts_id: number) => void;
  name: string;
  label?: string;
  options: IOptions[];
  bgStylesClass?: string;
  useSmallSize?: boolean;
  disabled?: boolean;
}

interface IOptions {
  label: string | number;
  value: string | number | boolean;
  disabled?: boolean;
}

const ProcessingStatusSelect: React.FC<IProps> = ({
  value,
  id,
  accounts_id,
  handleChange,
  label,
  options,
  name,
  bgStylesClass,
  useSmallSize,
  disabled,
}) => {
  return (
    <Select
      {...(useSmallSize && {
        baseSelectStyles: {
          className: cx(s.baseSelect, bgStylesClass),
          classes: {
            root: s.rootBaseSelect,
          },
        },
      })}
      name={name}
      size="small"
      options={options.map((opt) => ({
        text: opt.label as string,
        name: opt.value,
        disabled: opt?.disabled,
      }))}
      onChange={(e) => {
        return handleChange(e, id, accounts_id);
      }}
      disabled={[
        EProcessingStatuses.failed,
        EProcessingStatuses.completed,
        EDeprecatedInvoiceStatusesLiveFundedTrader.pro_paid,
        EDeprecatedInvoiceStatusesLiveFundedTrader.pre_sept_2023,
        EDeprecatedInvoiceStatusesLiveFundedTrader.pro_needs_invoice,
        EDeprecatedInvoiceStatusesLiveFundedTrader.delaying_fee,
        EDeprecatedInvoiceStatusesLiveFundedTrader.needs_setup_invoice,
      ].includes(value as EProcessingStatuses)}
      {...(disabled && { disabled: true })}
      value={value as string}
      {...(label && { inputLabel: label })}
      {...(label && { label })}
    />
  );
};

export default ProcessingStatusSelect;
